<template>
  <b-container class="contentcontainer">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('user.payment.addsepa')}}</h2>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>
        <h3>{{$t('user.payment.addsepainformation')}}</h3>
        <p>{{$t('user.payment.sepaintro')}}</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label="Name">
          <input class="form-control" id="name" name="name" placeholder="Account Holder" v-model="holder" required>
        </b-form-group>
        <b-form-group label="IBAN">
          <div id="iban-element">
            <!-- A Stripe Element will be inserted here. -->
          </div>
        </b-form-group>
        <button class="btn btn--success" id="card-button" v-bind:data-secret="intent" v-on:click="addSepa">{{$t('user.payment.submitsepa')}}</button>

        <!-- Used to display form errors. -->
        <div id="error-message" role="alert">{{errormessage}}</div>
        <p class="text-black-50 mt-5">
          {{$t('user.payment.sepanote')}}
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { mapMutations } from 'vuex'
import { STRIPE_KEY } from '../../common/config'

export default {

  name: 'payment',

  computed: {},

  data () {
    return {
      account: {},
      user: {},
      intent: {},
      edit: false,
      stripe: {},
      holder: '',
      elements: {},
      cardElement: {},
      iban: {},
      errormessage: '',
      errorcode: ''

    }
  },

  methods: {

    ...mapMutations([
      'setViewname'
    ]),

    ...mapMutations('common', [
      'endLoading'
    ]),

    addSepa () {
      this.errormessage = ''

      let sourceData = {
        type: 'sepa_debit',
        currency: 'eur',
        owner: {
          name: this.holder,
          email: this.user.email
        },
        mandate: {
          // Automatically send a mandate notification email to your customer
          // once the source is charged.
          notification_method: 'email'
        }
      }

      // Call `stripe.createSource` with the IBAN Element and additional options.
      this.stripe.createSource(this.iban, sourceData)
        .then((result) => {
          if (result.error) {
            // Inform the customer that there was an error.
            this.errormessage = this.$t('user.paymentaddsepa.error.' + result.error.code)
          } else {
          // Send the Source to your server.
            const payload = {
              type: 'SEPA',
              payment_method: result.source.id,
              created: result.source.created,
              mandate_state: result.source.mandate.acceptance.status,
              status: result.source.status,
              usage: result.source.usage,
              owner: result.source.owner.name,
              sepa_debit_last4: result.source.sepa_debit.last4,
              sepa_debit_mandate_reference: result.source.sepa_debit.mandate_reference
            }

            this.axios.post('/api/account/updatepaymentmethod', payload)
              .then(() => {
                this.$router.push({
                  name: 'userPayment'
                })
              })
          }
        })
    }
  },

  mounted () {
    let style = {
      base: {
        // Add your base input styles here. For example:
        fontSize: '16px',
        color: '#32325d'
      }
    }

    let options = {
      style: style,
      supportedCountries: ['SEPA'],
      // If you know the country of the customer, you can optionally pass it to
      // the Element as placeholderCountry. The example IBAN that is being used
      // as placeholder reflects the IBAN format of that country.
      placeholderCountry: 'DE'
    }

    this.elements = this.stripe.elements()

    // Create an instance of the iban Element.
    this.iban = this.elements.create('iban', options)

    // Add an instance of the iban Element into the `iban-element` <div>.
    this.iban.mount('#iban-element')
  },

  created () {
    this.setViewname(this.$t('user.paymentaddsepa.viewtitle'))
    this.stripe = window.Stripe(STRIPE_KEY)

    this.axios.get('/api/account').then(
      response => {
        this.account = response.data.data
      }
    )

    this.axios.get('/api/user').then(
      response => {
        this.user = response.data.data
      }
    )

    this.axios.get('/api/account/updatepayment').then(
      response => {
        this.intent = response.data[0]
        this.endLoading()
      }
    )
  }
}
</script>
